//natives
import React from 'react';
import CircularProgress from "@material-ui/core/CircularProgress";

//components
import Table from "../../../../Table/.mixins/Table";
import Filter from "../../../../../util/filter/.mixins/Filter";
import Error from "../../../../../util/error/.mixins/Error";

//css
import ComunicadosCss from './Lista-css';
const useStyles = ComunicadosCss();

export default function Lista(props) {
    const classes = useStyles();
    return (
        <div className="container">

            {props.state.isLoading &&
            <div align="center">
                <CircularProgress />
            </div>
            }
            {!props.state.isLoading && !props.state.isError &&
            <div>
                {/* <Filter {...props}/> */}
                <br/>
                <Table {...props} className={classes.root}/>
            </div>
            }
            {props.state.isError &&
            <div align="center">
                <Error text={props.state.error}/>
            </div>
            }

        </div>
    );
}